import { render, staticRenderFns } from "./AddSkillsetDialog.vue?vue&type=template&id=45a2e88e&scoped=true&"
import script from "./AddSkillsetDialog.ts?vue&type=script&lang=ts&"
export * from "./AddSkillsetDialog.ts?vue&type=script&lang=ts&"
import style0 from "./AddSkillsetDialog.vue?vue&type=style&index=0&id=45a2e88e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2e88e",
  null
  
)

export default component.exports